import { Button, Card, Col, Input, Progress, Row, Select, Tag } from "antd";

import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../../atoms/CustomIcons";

export default function Dashboard() {
  return (
    <div className="profileWrapper">
      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Stats</h3>
          <div>
            <Select
              suffixIcon={<SelectArrow />}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              allowClear
              placeholder="Filters"
              defaultValue="Filters"
              popupMatchSelectWidth={false}
              options={[
                {
                  value: "past_month",
                  label: "Past month",
                },
                {
                  value: "past_6_months",
                  label: "Past 6 months",
                },
                {
                  value: "past_quarter",
                  label: "Past quarter",
                },
                {
                  value: "past_year",
                  label: "Past year",
                },
              ]}
            />
          </div>
        </div>
        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Production efficiency</div>
                <div className="info" style={{ color: "#00A07D" }}>
                  102%
                </div>
              </div>

              <div className="progressInfoCrews">
                <h6> Estimated hours </h6>
                <Progress
                  success={{ percent: 100, strokeColor: "#6454F4" }}
                  showInfo={false}
                  size={["100%", 12]}
                />

                <div className="infoValue"> 6,560 </div>
              </div>
              <div className="progressInfoCrews">
                <h6> Actual hours </h6>
                <Progress
                  success={{ percent: 97, strokeColor: "#00A07D" }}
                  showInfo={false}
                  strokeColor="#E04949"
                  size={["100%", 12]}
                />

                <div className="infoValue"> 6,402 </div>
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Total labor GM</div>
                <div className="info" style={{ color: "#00A07D" }}>
                  +2%
                </div>
              </div>

              <div className="progressInfoCrews">
                <h6> Estimated </h6>
                <Progress
                  success={{ percent: 90, strokeColor: "#6454F4" }}
                  showInfo={false}
                  size={["100%", 12]}
                />

                <div className="infoValue"> 38% </div>
              </div>
              <div className="progressInfoCrews">
                <h6> Actual </h6>

                <Progress
                  success={{ percent: 100, strokeColor: "#00A07D" }}
                  showInfo={false}
                  strokeColor="#00A07D"
                  size={["100%", 12]}
                />

                <div className="infoValue"> 40% </div>
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Utilization rate</div>
                <div className="info" style={{ color: "#E04949" }}>
                  101%
                </div>
              </div>

              <div className="progressInfoCrews">
                <h6> Regular hours </h6>
                <Progress
                  success={{ percent: 98, strokeColor: "#6454F4" }}
                  showInfo={false}
                  size={["100%", 12]}
                />

                <div className="infoValue"> 7,680 </div>
              </div>
              <div className="progressInfoCrews">
                <h6> Actual hours </h6>
                <Progress
                  success={{ percent: 100, strokeColor: "#E04949" }}
                  showInfo={false}
                  strokeColor="#E04949"
                  size={["100%", 12]}
                />

                <div className="infoValue"> 7,757 </div>
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">
                  Average earned revenue per labor hour
                </div>
                <div className="info">$49</div>
              </div>

              <div className="progressInfoCrews">
                <h6> Avg labor cost </h6>
                <Progress
                  success={{ percent: 90, strokeColor: "#6454F4" }}
                  showInfo={false}
                  size={["100%", 12]}
                />

                <div className="infoValue"> $32 </div>
              </div>
              <div className="progressInfoCrews">
                <h6> Avg earned revenue </h6>

                <Progress
                  success={{ percent: 100, strokeColor: "#00A07D" }}
                  showInfo={false}
                  strokeColor="#00A07D"
                  size={["100%", 12]}
                />

                <div className="infoValue"> $49 </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Card>

      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Contracts</h3>
        </div>

        <Card style={{ borderRadius: "16px" }}>
          <Row gutter={[0, 4]}>
            <Col span={24}>
              <div className="filtersWrapper" style={{ marginBottom: "12px" }}>
                <div
                  className="filtersTop"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="filterSearch">
                    <Input
                      prefix={<SearchIcon />}
                      placeholder="Search contracts"
                      allowClear
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div className="filterToggle">
                      <Button
                        icon={<FilterIcon />}
                        className="outlined-btn"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Filters
                        <div className="filter_icon">
                          <SelectArrow />
                        </div>
                      </Button>
                    </div>
                    <div className="filterDownload">
                      <Button
                        icon={<DownloadIcon />}
                        style={{ height: "36px", width: "36px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <Card className="contactCard crewsContactCard">
                <div className="contactCardLeft">
                  <div className="namePosition">
                    <Tag style={{ marginBottom: "16px" }}>
                      Unit 10 - 1403 Cleveland St
                    </Tag>
                    <h4>Maintenance Agreement 21567</h4>
                    <p style={{ fontSize: "14px", marginBottom: "16px" }}>
                      Mar 12, 2025 - Mar 12, 2026
                    </p>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <Tag className="default_tag mint_tag">
                        Landscape maintenance
                      </Tag>
                      <Tag className="default_tag purple_tag">Irrigation</Tag>
                    </div>
                  </div>

                  <div className="infoText">
                    <div className="labelText">Account manager</div>
                    <div className="valueText">
                      <img
                        src="/images/dummy/checkList_dp_2.png"
                        alt=""
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "100px",
                        }}
                      />
                      Andrew O.
                    </div>
                  </div>

                  <div className="infoText">
                    <div className="labelText">Product manager</div>
                    <div className="valueText">
                      <img
                        src="/images/dummy/checkList_dp_4.svg"
                        alt=""
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "100px",
                        }}
                      />
                      Brad T.
                    </div>
                  </div>

                  <div className="infoText">
                    <Card className="dealsInnerCardItem greenCard">
                      <div
                        className="innerLabel"
                        style={{ marginBottom: "12px" }}
                      >
                        Status
                      </div>
                      <Tag
                        className="default_tag accepted_tag"
                        style={{ color: "#fff" }}
                      >
                        Active
                      </Tag>
                      <img
                        src="/images/grey_filled_success.svg"
                        alt=""
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "12px",
                        }}
                      />
                    </Card>
                  </div>
                </div>
              </Card>

              <Card className="contactCard crewsContactCard">
                <div className="contactCardLeft">
                  <div className="namePosition">
                    <Tag style={{ marginBottom: "16px" }}>
                      Sapphire Springs Villas
                    </Tag>
                    <h4>Maintenance Agreement 21570</h4>
                    <p style={{ fontSize: "14px", marginBottom: "16px" }}>
                      Mar 12, 2025 - Mar 12, 2026
                    </p>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <Tag className="default_tag mint_tag">
                        Landscape maintenance
                      </Tag>
                    </div>
                  </div>

                  <div className="infoText">
                    <div className="labelText">Account manager</div>
                    <div className="valueText">
                      <img
                        src="/images/dummy/checkList_dp_2.png"
                        alt=""
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "100px",
                        }}
                      />
                      Andrew O.
                    </div>
                  </div>

                  <div className="infoText">
                    <div className="labelText">Product manager</div>
                    <div className="valueText">
                      <img
                        src="/images/dummy/checkList_dp_4.svg"
                        alt=""
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "100px",
                        }}
                      />
                      Brad T.
                    </div>
                  </div>

                  <div className="infoText">
                    <Card className="dealsInnerCardItem greenCard">
                      <div
                        className="innerLabel"
                        style={{ marginBottom: "12px" }}
                      >
                        Status
                      </div>
                      <Tag
                        className="default_tag accepted_tag"
                        style={{ color: "#fff" }}
                      >
                        Active
                      </Tag>
                      <img
                        src="/images/grey_filled_success.svg"
                        alt=""
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "12px",
                        }}
                      />
                    </Card>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Card>
      </Card>
    </div>
  );
}
